import { render } from "./RaceItem.vue?vue&type=template&id=90180394&scoped=true"
import script from "./RaceItem.vue?vue&type=script&lang=js"
export * from "./RaceItem.vue?vue&type=script&lang=js"

import "./RaceItem.vue?vue&type=style&index=0&id=90180394&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90180394"]])

export default __exports__